import React, { FC } from 'react';
import { AuctionsListing, Layout } from '../../components';

const Auction: FC = (props) => {
  const footerData = props?.footerData?.data?.attributes;

  return (
    <Layout footerData={footerData} activeNavIndex={0} title="Auctions">
      <AuctionsListing />
    </Layout>
  );
};

export default Auction;
